export const inputRule = (root = document) => {
  const formSelectors = '[data-form-validate]';

  const getRequiredFields = (form) => {
    const inputs = form.querySelectorAll(`
      .footer-input__surname,
      .footer-input__name,
      .footer-input__phone,
      input.footer-input__mail:not([placeholder*="промокод"])
    `);
    const textarea = form.querySelector('.footer-input__textarea');
    const checkbox = form.querySelector('.footer-agrees input[type="checkbox"]');

    const fields = [...inputs];
    if (textarea) fields.push(textarea);
    if (checkbox) fields.push(checkbox);

    return fields;
  };

  const getSubmitButton = (form) => {
    return form.querySelector('.footer__btn, .modal-submit-btn');
  };

  const getErrorSpan = (form) => {
    return form.querySelector('.modal-promo__text-anderror .legal-2');
  };

  const getFieldErrorMessage = (field) => {
    if (field.type === 'checkbox') {
      return 'Необходимо дать согласие на обработку персональных данных';
    }
    if (field.classList.contains('footer-input__surname')) {
      return 'Пожалуйста, введите фамилию';
    }
    if (field.classList.contains('footer-input__name')) {
      return 'Пожалуйста, введите имя';
    }
    if (field.classList.contains('footer-input__phone')) {
      return 'Пожалуйста, введите корректный номер телефона';
    }
    if (field.classList.contains('footer-input__mail') && field.placeholder && !field.placeholder.includes('промокод')) {
      return 'Пожалуйста, введите корректный адрес электронной почты';
    }
    return 'Пожалуйста, заполните это поле';
  };

  const isFieldValid = (field) => {
    if (field.type === 'checkbox') {
      return field.checked;
    }
    const value = (field.value || '').trim();
    if (value.length === 0) return false;
    if (field.classList.contains('footer-input__phone')) {
      const digits = value.replace(/\D/g, '');
      const len = digits.length;
      if (len < 10) return false;
      if (digits[0] === '7' || digits[0] === '8') return len >= 11;
      return len >= 10; // 9XXXXXXXXX
    }
    if (field.classList.contains('footer-input__mail') && field.placeholder !== 'промокод' && !field.placeholder.includes('промокод')) {
      if (!value.includes('@')) return false;
      const [local, domain] = value.split('@');
      return local.length >= 1 && domain && domain.includes('.') && domain.split('.').pop().length >= 2;
    }
    return true;
  };

  const isFormValid = (form) => {
    const fields = getRequiredFields(form);
    return fields.every(isFieldValid);
  };

  const showError = (form, message) => {
    const errorSpan = getErrorSpan(form);
    if (errorSpan) {
      errorSpan.textContent = message;
      errorSpan.classList.add('active');
    }
  };

  const hideError = (form) => {
    const errorSpan = getErrorSpan(form);
    if (errorSpan) {
      errorSpan.textContent = '';
      errorSpan.classList.remove('active');
    }
  };

  const validateFormOnSubmit = (form, btn, preventDefault = false) => {
    const fields = getRequiredFields(form);
    const invalidField = fields.find(field => !isFieldValid(field));

    if (invalidField) {
      const errorMessage = getFieldErrorMessage(invalidField);
      showError(form, errorMessage);
      if (invalidField.type !== 'checkbox') {
        invalidField.focus();
      }
      form.dataset.formValid = 'false';
      if (preventDefault) {
        return false;
      }
      return false;
    }

    hideError(form);
    form.dataset.formValid = 'true';
    return true;
  };

  const setupForm = (form) => {
    const fields = getRequiredFields(form);
    const btn = getSubmitButton(form);

    if (!btn) return;

    btn.disabled = false;

    form.dataset.formValid = 'false';

    const handleChange = () => {
      hideError(form);
      if (isFormValid(form)) {
        form.dataset.formValid = 'true';
      } else {
        form.dataset.formValid = 'false';
      }
    };

    fields.forEach((field) => {
      field.addEventListener('input', handleChange);
      field.addEventListener('change', handleChange);
    });

    btn.addEventListener('click', (e) => {
      if (!btn.disabled) {
        const isValid = validateFormOnSubmit(form, btn, true);
        if (!isValid) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    });
  };

  root.querySelectorAll(formSelectors).forEach(setupForm);
};
